/**
 * Section: sell-your-soul-register.js
 * ------------------------------------------------------------------------------
 * This snippet gets the accepted_by input field and fills automatically with the value entered in the first_name input field.
 */

document.addEventListener('DOMContentLoaded', () => {
	if (document.querySelector('.sell-your-soul-register')) {
		const firstNameInput = document.getElementById('RegisterForm-FirstName');
		const lastNameInput = document.getElementById('RegisterForm-LastName');
		const acceptedByInput = document.getElementById('accepted_by');

		function updateAcceptedBy() {
			acceptedByInput.value = `${firstNameInput.value} ${lastNameInput.value}`;
		}

		if (firstNameInput && lastNameInput && acceptedByInput) {
			firstNameInput.addEventListener('input', updateAcceptedBy);
			lastNameInput.addEventListener('input', updateAcceptedBy);
		}
	}
});
